import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';

const Wrapper = styled.div`
  height: ${({ theme }) => theme.spacing.values.x16};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const PieChartPlaceholder = styled(Skeleton)`
  height: ${({ theme }) => theme.spacing.values.x10};
  width: ${({ theme }) => theme.spacing.values.x10};
  border-radius: ${({ theme }) => theme.spacing.values.x10};
`;

export const PIE_CHART_SKELETON_DATA_TEST = 'pie-chart-skeleton';

export const PieChartSkeleton = () => (
  <Wrapper data-test={PIE_CHART_SKELETON_DATA_TEST}>
    <PieChartPlaceholder />
  </Wrapper>
);
